import { ServiceAccessTokenLevel } from '@api';

export const ACCESS_MANAGEMENT_PATH = {
  ACCESS_MANAGEMENT: '/accessManagement',
  DEFAULT_WORKSPACE_POLICY: '/accessManagement/policy/:workspaceId',
  GET_DEFAULT_WORKSPACE_POLICY_PATH: (workspaceId: string) =>
    `/accessManagement/policy/${workspaceId}`,
  GROUPS: '/accessManagement?tab=groups',
  SCIM_GROUP_MAPPING: '/accessManagement?tab=group_mapping',
  GROUP_DETAILS: '/accessManagement/groups/:groupId',
  GET_GROUP_DETAILS_PATH: (groupId: string) => `/accessManagement/groups/${groupId}`,
  GROUP_WORKSPACE_POLICY: '/accessManagement/groups/:groupId/policy/:workspaceId',
  GET_GROUP_WORKSPACE_POLICY_PATH: (groupId: string, workspaceId: string) =>
    `/accessManagement/groups/${groupId}/policy/${workspaceId}`,
  MEMBERS: '/accessManagement?tab=users',
  MEMBER_DETAILS: '/accessManagement/members/:memberId',
  GET_MEMBER_DETAILS_PATH: (memberId: string) => `/accessManagement/members/${memberId}`,
  MEMBER_WORKSPACE_POLICY: '/accessManagement/members/:userId/policy/:workspaceId',
  GET_MEMBER_WORKSPACE_POLICY_PATH: (userId: string, workspaceId: string) =>
    `/accessManagement/members/${userId}/policy/${workspaceId}`,
  GET_SERVICE_ACCESS_TOKENS_PATH: (level?: ServiceAccessTokenLevel) =>
    `/accessManagement?tab=service_access_tokens${level ? `&level=${level}` : ''}`,
  SERVICE_ACCESS_TOKEN_POLICY: '/accessManagement/serviceAccessTokens/:tokenId/policy/:workspaceId',
  GET_SERVICE_ACCESS_TOKEN_POLICY_PATH: (tokenId: string, workspaceId: string) =>
    `/accessManagement/serviceAccessTokens/${tokenId}/policy/${workspaceId}`,
  INVITATIONS: '/accessManagement?tab=invitations',
  INVITE_USERS: '/accessManagement?tab=invitations&invite=true',
};
